<form novalidate role="form" [formGroup]="form" autocomplete='off'>
    <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"><span
                aria-hidden="true">&times;</span></button>
        <h4 class="modal-title" id="labelButtons">Add Requirements</h4>
    </div>
    <div class="modal-body" *ngIf="displayResults">
        <h2>{{title}} <button class="icon--add btn--default" type="button" (click)="addDocumentRequirement()"> Add Category/Type</button></h2>
        <p-table #dt [value]="documentRequirements" formArrayName="documentRequirementArray">
            <ng-template pTemplate="header">
                <tr>
                    <th class="required" title="* Required">Document Category</th>
                    <th class="required" title="* Required">Document Type</th>
                    <th class="w--icon">Remove</th>
                    <th *ngIf="isBusinessTransaction">Scan Later</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-requirement let-i="rowIndex">
                <tr [pSelectableRow]="requirement" [formGroupName]="i">
                    <td>
                        <p-dropdown [options]="documentCategoryTypes" [appendTo]="dropdownTarget"
                                    id="documentCategoryTypeId{{requirement.requirementViewId}}" placeholder="Select"
                                    filter="true"
                                    (onChange)="documentCategoryTypeSelected(requirement.requirementViewId, $event.value)"
                                    formControlName="documentCategoryTypeId"></p-dropdown>
                    </td>
                    <td>
                        <p-dropdown [options]="requirement.documentTypes" [appendTo]="dropdownTarget"
                                id="documentTypeId{{requirement.requirementViewId}}" placeholder="Select"
                                filter="true"
                                (onChange)="documentTypeSelected(requirement.requirementViewId, $event.value)"
                                formControlName="documentTypeId"></p-dropdown>
                    </td>
                    <td class="text-center">
                        <a class="icon--remove" title="Remove" href="javascript:void(0);" (click)="removeDocumentRequirement(i)"></a>
                    </td>
                    <td *ngIf="isBusinessTransaction">
                        <input id="scanLater{{requirement.requirementViewId}}" (change)="onScanLaterChanged($event, requirement)"
                               name="scanLater{{requirement.requirementViewId}}" type="checkbox"
                               formControlName="scanLater" />
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <div class="modal-footer">
        <div class="btn--group">
            <button class="btn--default" type="button" data-bs-dismiss="modal" (click)="close()">Close</button>
            <button class="btn--primary" type="button" (click)="save()"
                [disabled]="isFormInvalid || isBusy">Save</button>
        </div>
    </div>
</form>